module.exports = __webpack_public_path__ + "img/firewall-1.d5f62dbb.webp";